import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import axios from 'axios'
import { VueMaskDirective } from 'v-mask'
import VeeValidate from 'vee-validate'
import VCurrencyField from 'v-currency-field'
import IdleVue from 'idle-vue'
import CKEditor from 'ckeditor4-vue';
import VueCompositionAPI from '@vue/composition-api'
import VueObserveVisibility from "vue-observe-visibility";

import('./assets/styles/global.scss')
if (window.location.host === process.env.VUE_APP_SAVITARNA_HOST) {
  const savitarnaStyle = process.env.VUE_APP_SAVITARNA_STYLE ?? 'savitarna.css'
  import('./assets/styles/' + savitarnaStyle)
}

document.fonts.ready.then(function () {
  window.dispatchEvent(new Event('resize'))
})

const ComponentContext = require.context(
  './components/elements',
  true,
  /\.vue$/i,
  'lazy'
)

ComponentContext.keys().forEach((componentFilePath) => {
  const componentName = componentFilePath.split('/').pop().split('.')[0]
  Vue.component(componentName, () => ComponentContext(componentFilePath))
})

axios.defaults.baseURL = store.getters.appBaseApi
axios.interceptors.request.use((config) => {
  if (window.location.host === process.env.VUE_APP_SAVITARNA_HOST) {
    if(config.method == 'get'){
      const requestParams = config.params
      const appLocaleParam = {appLocale: store.getters.getSystemLang}
      config.params = {...requestParams , ...appLocaleParam}
    }
    if(config.method == 'post'){
      if(config.data?.constructor == Object){
        const requestData = config.data
        const appLocaleData = {appLocale: store.getters.getSystemLang}
        config.data = {...requestData , ...appLocaleData}
      } else if (config.data == undefined) {
        const requestData = config.data
        const appLocaleData = {appLocale: store.getters.getSystemLang}
        config.data = {...requestData , ...appLocaleData}
      } else {
        config.data.append('appLocale', store.getters.getSystemLang)
      }
    }
  } 
  config.headers['Content-Type'] = 'application/json'
  config.headers['Authorization'] = 'Bearer ' + store.getters.getAccessToken
  return config
})
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status == 401) {
      window._VMA.$emit('AUTH_FAILED')
      return
    }
    return Promise.reject(error)
  }
)
Vue.prototype.$axios = axios

Vue.directive('mask', VueMaskDirective)
Vue.use(VCurrencyField)
Vue.use( CKEditor );
Vue.use(VueCompositionAPI)
Vue.use(VueObserveVisibility);

const idleOptions = {
  store,
  idleTime: store.getters.getExpiresIn,
  startAtIdle: false,
  keepTracking: true,
}
Vue.use(IdleVue, idleOptions)

const veeConfig = {
  events: 'blur',
  inject: false,
}
Vue.use(VeeValidate, veeConfig)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
